let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("700Vl")).then(() => parcelRequire('1pQ0C'));